import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit {
  images = [
    {path: '../../../../assets/img/client_icons/mlb_200w.png',
     title: 'MLB',
    alt: 'MLB'
    },
    {path: '../../../../assets/img/client_icons/mls_200w.png',
     title: 'MLS',
     alt: 'MLS'
    },
    {path: '../../../../assets/img/client_icons/nascar_200w.png',
     title: 'NASCAR',
     alt: 'NASCAR'
    },
    {path: '../../../../assets/img/client_icons/ncaa_200w.png',
     title: 'NCAA',
     alt: 'NCAA'
    },
    {path: '../../../../assets/img/client_icons/NFL_200w.png',
     title: 'NFL',
     alt: 'NFL'
    },
    {path: '../../../../assets/img/client_icons/nhl_200w.png',
     title: 'NHL',
     alt: 'NHL'
    },
    {path: '../../../../assets/img/client_icons/pga_200w.png',
     title: 'PGA',
     alt: 'PGA'
    },
    {path: '../../../../assets/img/client_icons/rosebowl_200w.png',
     title: 'Rose Bowl',
     alt: 'Rose Bowl'
    },
    {path: '../../../../assets/img/client_icons/sofistadium_200w.png',
     title: 'MLB',
     alt: 'SoFi Stadium'
    },
    {path: '../../../../assets/img/client_icons/nba2_200w.jpeg',
     title: 'NBA',
     alt: 'NBA'
    }
];
cellsToShow = 4;
loop = true;
size = 'contain';

  constructor() { }

  ngOnInit(): void {
    // const prev = document.querySelector('.prev');
    // const next = document.querySelector('.next');
    // const track = document.querySelector('.track') as HTMLElement;

    // const carouselWidth = document.querySelector<HTMLElement>('.carousel-container').offsetWidth;

    // console.log('CarouselWidth', carouselWidth);

    // next.addEventListener('click', () => {
    //   track.style.transform = `translateX(-${carouselWidth}px)`;
    // })
    // prev.addEventListener('click', () => {
    //   track.style.transform = `translateX(${0}px)`;
    // })

    const slides = document.querySelectorAll('.slide');
const next = document.querySelector('#next');
const prev = document.querySelector('#prev');
const auto = true; // Auto scroll
const intervalTime = 1500;
let slideInterval;

const nextSlide = () => {
  // Get current class
  const current = document.querySelector('.current');
  // Remove current class
  current.classList.remove('current');
  // Check for next slide
  if (current.nextElementSibling) {
    // Add current to next sibling
    current.nextElementSibling.classList.add('current');
  } else {
    // Add current to start
    slides[0].classList.add('current');
  }
  setTimeout(() => current.classList.remove('current'));
};

const prevSlide = () => {
  // Get current class
  const current = document.querySelector('.current');
  // Remove current class
  current.classList.remove('current');
  // Check for prev slide
  if (current.previousElementSibling) {
    // Add current to prev sibling
    current.previousElementSibling.classList.add('current');
  } else {
    // Add current to last
    slides[slides.length - 1].classList.add('current');
  }
  setTimeout(() => current.classList.remove('current'));
};

// Button events
next.addEventListener('click', e => {
  nextSlide();
  if (auto) {
    clearInterval(slideInterval);
    slideInterval = setInterval(nextSlide, intervalTime);
  }
});

prev.addEventListener('click', e => {
  prevSlide();
  if (auto) {
    clearInterval(slideInterval);
    slideInterval = setInterval(nextSlide, intervalTime);
  }
});

// Auto slide
if (auto) {
  // Run next slide at interval time
  slideInterval = setInterval(nextSlide, intervalTime);
}


  }
}
